import Component from '../app/component'

export default class ProductbottomComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {}
  }

  init () {
    if (this.refs.facebook) {
      this.refs.facebook.href = `https://www.facebook.com/sharer.php?u=${encodeURI(window.location.href)}`
    }
    if (this.refs.linkedin) {
      this.refs.linkedin.href = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURI(window.location.href)}`
    }
    if (this.refs.twitter) {
      this.refs.twitter.href = `https://twitter.com/intent/tweet?url=${encodeURI(window.location.href)}`
    }
  }
}
